import ApiConection from 'api_ref/ApiConection';
import Css from 'components/pages/application/login/Login.module.css';
import { useState, useEffect } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';

export default function ProfileCompany({ data = undefined, callSubmitParentData = undefined, parentAlert = '' }) {
    //console.log(data);
    const api = new ApiConection();

    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [simulate, setSimulate] = useState(data);

    const [businessTypeData, setBusinessTypeData] = useState([]);
    const getBusinessTypeData = async () => {
        const response = await api.getData(`api/master/business-type`);
        if (response.status == true) {
            setBusinessTypeData(response.data);
        }

        //console.log(businessTypeData);
    }
    const getBusinessTypeValue = (id) => {
        const result = businessTypeData.find(x => x.id == id);
        return result?.name;
    }

    const [businessCategoryData, setBusinessCategoryData] = useState([]);
    const getBusinessCategoryData = async () => {
        const response = await api.getData(`api/master/business-category`);
        if (response.status == true) {
            setBusinessCategoryData(response.data);
        }
    }
    const getBusinessCategoryValue = (id) => {
        const result = businessCategoryData.find(x => x.id == id);
        return result?.name;
    }

    const [employeeCount, setEmployeeCount] = useState([]);
    const getEmployeeCount = async () => {
        const response = await api.getData(`api/master/employee-count`);
        if (response.status == true) {
            setEmployeeCount(response.data);
        }
    }
    const getBusinessEmployeeCountValue = (id) => {
        const result = employeeCount.find(x => x.id == id);
        return result?.name;
    }

    useEffect(() => {
        getBusinessTypeData();
        getBusinessCategoryData();
        getEmployeeCount();
    }, []);

    const handleSetSimulate = (event) => {
        let { name, value, checked, type } = event.target;

        if (type === 'checkbox') {
            setSimulate(prevData => {
                return { ...prevData, [name]: checked }
            })
        } else {
            setSimulate(prevData => {
                return { ...prevData, [name]: value }
            })
        }
    }

    const handleCancel = (event) => {
        setSimulate(data);
        setAlert('');
        setMode('view');
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        const response = await callSubmitParentData(simulate);

        if (response == true) {
            setMode('view');
        } else {
            setMode('edit');
            setSimulate(data);
        }

        setLoading(false);
    }

    useEffect(() => {
        setAlert(parentAlert);
    }, [parentAlert])

    return (
        data !== undefined &&
        <div className='mt-3 mb-3'>
            <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                <div className={`border rounded p-4 bg-white shadow w-100`}>
                    <h6 className='mb-4'>
                        <Row>
                            <Col><h5 className='text-start text-blue-01'>ข้อมูลบริษัท</h5></Col>
                            <Col className='text-end'>
                                {
                                    mode === 'view' &&
                                    <Button variant="outline-secondary" type="button" className=''
                                        onClick={event => setMode('edit')}>
                                        แก้ไข
                                        <i className="ms-2 fa-solid fa-pencil"></i>
                                    </Button>
                                }
                            </Col>
                        </Row>
                    </h6>
                    <div>
                        <Row className='mb-3'>
                            <Col >
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>รหัสลูกค้า</Form.Label>
                                    <Form.Control type={'text'}
                                        plaintext={true}
                                        readOnly={true}
                                        className='border-bottom'
                                        value={simulate?.register_number} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='mb-5'>
                            <Col className='me-3'>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>ชื่อบริษัท</Form.Label>
                                    <Form.Control type={'text'}
                                        plaintext={(mode === 'view') ? true : false}
                                        readOnly={(mode === 'view') ? true : false}
                                        className=''
                                        name={'company_name'}
                                        value={simulate?.company_name}
                                        onChange={handleSetSimulate}
                                        placeholder="ชื่อบริษัท" required={true} />
                                </Form.Group>
                                <Form.Group className='mb-3'>
                                    <Form.Label className='label-title'>ที่อยู่</Form.Label>
                                    {
                                        mode === 'view' &&
                                        <Col>
                                            <Form.Label className='d-block pt-2 pb-1'>{simulate?.company_address}</Form.Label>
                                        </Col>
                                    }
                                    {
                                        mode === 'edit' &&
                                        <Form.Control type={'text'}
                                            plaintext={(mode === 'view') ? true : false}
                                            readOnly={(mode === 'view') ? true : false}
                                            className=''
                                            name={'company_address'}
                                            value={simulate?.company_address}
                                            onChange={handleSetSimulate}
                                            placeholder="ชื่อบริษัท" required={true}
                                            as="textarea" rows={3} />
                                    }
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>หมายเลขโทรศัพท์</Form.Label>
                                    <Form.Control type={'tel'}
                                        plaintext={(mode === 'view') ? true : false}
                                        readOnly={(mode === 'view') ? true : false}
                                        className=''
                                        name={'company_tel'}
                                        value={simulate?.company_tel}
                                        placeholder="00-000-0000" required={true}
                                        onChange={handleSetSimulate} />
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>เลขประจำตัวผู้เสียภาษีอากร</Form.Label>
                                    <Form.Control type={'text'}
                                        plaintext={(mode === 'view') ? true : false}
                                        readOnly={(mode === 'view') ? true : false}
                                        className=''
                                        name={'tax_id'}
                                        value={simulate?.tax_id}
                                        placeholder="0000000000000"
                                        maxLength={13} pattern="[0-9]{13}"
                                        onChange={handleSetSimulate} />
                                    <Form.Control.Feedback type={'invalid'}>รูปแบบเลขประจำตัวผู้เสียภาษีไม่ถูกต้อง</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>ที่อยู่ไซต์ (Site URL)</Form.Label>
                                    <Form.Control type={'text'} plaintext readOnly
                                        className=''
                                        placeholder="Site URL"
                                        value={simulate?.full_site_url} />
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>ใช้งาน ISO-DCaaS</Form.Label>
                                    <Form.Check type={'switch'}
                                        id={'chk_active_dcaas'}
                                        name={'active_dcaas'}
                                        disabled={(mode === 'view') ? true : false}
                                        onChange={event => handleSetSimulate(event)}
                                        checked={simulate?.active_dcaas ?? true}
                                        label={(simulate?.active_dcaas == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                    />
                                </Form.Group>
                                <Form.Group className='mb-2'>
                                    <Form.Label className='label-title'>ใช้งาน Portal</Form.Label>
                                    <Form.Check type={'switch'}
                                        id={'chk_active'}
                                        name={'active'}
                                        disabled={(mode === 'view') ? true : false}
                                        onChange={event => handleSetSimulate(event)}
                                        checked={simulate?.active ?? true}
                                        label={(simulate?.active == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                    />

                                </Form.Group>
                            </Col>
                            <Col className='ps-4 border-start'>
                                <Form.Group className='mb-2'  >
                                    <Form.Label className='label-title'>ประเภทธุรกิจ</Form.Label>
                                    {
                                        mode === 'view' &&
                                        <Form.Label className='d-block pt-2 pb-1 '>{getBusinessTypeValue(simulate?.business_type_id)}</Form.Label>
                                    }
                                    {
                                        mode === 'edit' &&
                                        <Form.Select name={'business_type_id'}
                                            value={simulate?.business_type_id}
                                            placeholder="0000000000000"
                                            onChange={handleSetSimulate} >
                                            <option value={''} >-- ไม่ระบุ --</option>
                                            {
                                                businessTypeData.map((obj, index) => {
                                                    return (
                                                        <option key={index} value={obj.id} >{obj.name}</option>
                                                    )
                                                })
                                            }
                                        </Form.Select>
                                    }

                                </Form.Group>
                                <Form.Group className='mb-2 mt-3'  >
                                    <Form.Label className='label-title'>ลักษณะธุรกิจ</Form.Label>
                                    {
                                        mode === 'view' &&
                                        <Form.Label className='d-block pt-2 pb-1 '>{getBusinessCategoryValue(simulate?.business_category_id)} </Form.Label>
                                    }
                                    {
                                        mode === 'edit' &&
                                        <Form.Select name={'business_category_id'}
                                            value={simulate?.business_category_id}
                                            onChange={handleSetSimulate}
                                        >
                                            <option value={''} >-- ไม่ระบุ --</option>
                                            {
                                                businessCategoryData.map((obj, index) => {
                                                    return (
                                                        <option key={index} value={obj.id} >{obj.name}</option>
                                                    )
                                                })
                                            }
                                        </Form.Select>
                                    }

                                    {
                                        (simulate?.business_category_id == 99 && mode === 'view') &&
                                        (<Form.Label> : {simulate?.business_category_name}</Form.Label>)
                                    }
                                    {
                                        (simulate?.business_category_id == 99 && mode === 'edit') &&
                                        (<Form.Control as={'textarea'} className='mt-1' rows={3} placeholder="โปรดระบุ" name={'business_category_name'}
                                            value={simulate?.business_category_name}
                                            onChange={handleSetSimulate} />)
                                    }
                                </Form.Group>

                                <Form.Group className='mb-3 mt-3' >
                                    <Form.Label className='label-title'>จำนวนพนักงาน</Form.Label><br />
                                    {
                                        mode === 'view' &&
                                        <Form.Label className='d-block pt-2 pb-1 '>{getBusinessEmployeeCountValue(simulate?.employee_count_id)}</Form.Label>
                                    }
                                    {
                                        mode === 'edit' &&
                                        employeeCount.map((obj, index) => (
                                            <Form.Check type="radio" inline
                                                key={index}
                                                name={"employee_count_id"}
                                                id={'employee_count_id' + obj.id}
                                                label={obj.name}
                                                defaultChecked={obj.id == simulate?.employee_count_id}
                                                value={obj.id}
                                                onChange={handleSetSimulate}
                                            />
                                        ))
                                    }
                                </Form.Group>

                                <Form.Group className='mb-2 mt-3' >
                                    <Form.Label className='label-title' >รายละเอียดอื่นๆ</Form.Label>
                                    {
                                        mode === 'view' &&
                                        <Form.Label className='d-block pt-2 pb-1 '>{simulate?.description}</Form.Label>
                                    }
                                    {
                                        mode === 'edit' &&
                                        <Form.Control as={'textarea'} rows={3}
                                            name={'description'}
                                            value={simulate?.description}
                                            placeholder="ข้อมูลอื่นๆ เพิ่มเติม"
                                            onChange={handleSetSimulate} />
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                            alert != '' &&
                            <div className="alert alert-danger" role="alert">
                                {alert}
                            </div>
                        }

                        {
                            mode === 'edit' &&
                            <Row>
                                <Col>
                                    <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                        onClick={event => handleCancel(event)}  >ยกเลิก</Button>
                                    <Button variant="primary" type="submit" className='ps-5 pe-5'
                                        disabled={loading}
                                    >บันทึก
                                        {
                                            loading === true &&
                                            <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        }

                    </div>
                </div>
            </Form>
        </div>
    )
}